import PropTypes from 'prop-types';
import React from 'react';

export default class Error extends React.Component {
    static propTypes = {
        msg: PropTypes.string,
        dismiss: PropTypes.func.isRequired
    };
    
    static defaultProps = {
        msg: null,
        dismiss: (e) => false
    };

    render() {
        if (!this.props.msg) {
            return null;
        }
        return <div className="error" onClick={this.props.dismiss}>{this.props.msg}</div>;
    }
}


// WEBPACK FOOTER //
// ./src/kpi/components/Error.jsx